/*
 *  ************************************************************************
 *  *  © [2015 - 2020] Quintype Technologies India Private Limited
 *  *  All Rights Reserved.
 *  *************************************************************************
 */
import React from "react";
import get from "lodash/get";
import { LoadMoreStoriesBase, Collection } from "@quintype/components";
import { FullscreenStoryList } from "../layout/fullscreen-story-list.js";
import PropTypes from "prop-types";
import { collectionWithIntroductionCard } from "../../utils";
import { getCollectionTemplate } from "../get-collection-template.js";
class TagPage extends React.Component {
  render() {
    const stories = get(this.props, ["data", "stories"], []);
    const collection = collectionWithIntroductionCard(this.props.config, stories, "tag", this.props.data);
    const pbLayout = get(this.props.config, ["pagebuilder-config", "tag", "rows"], []);

    const TagPagCollectionLayout = () => {
      return (
        <Collection config={this.props.config} collection={collection} collectionTemplates={getCollectionTemplate} />
      );
    };

    return (
      <>{pbLayout.length > 0 ? <TagPagCollectionLayout /> : <LoadMoreStories {...this.props} stories={stories} />}</>
    );
  }
}

TagPage.propTypes = {
  data: PropTypes.object,
  stories: PropTypes.arraycreateConfigItem,
  config: PropTypes.object
};

function LoadMoreStories(props) {
  const storyFields =
    "headline,subheadline,summary,sections,tags,author-name,author-id,authors,updated-at,last-published-at,published-at,updated-at,first-published-at,hero-image-metadata,hero-image-s3-key,story-content-id,slug,id,seo,story-template,url";
  const data = Object.assign({}, props.data, { stories: props.stories });
  const tagSlugs = get(props, ["data", "tagSlug"]);
  const numStoriesToLoad = 20;

  return (
    <LoadMoreStoriesBase
      template={LoadMoreStoriesTemplate}
      fields={storyFields}
      params={{ "tag-slugs": tagSlugs }}
      data={data}
      numStoriesToLoad={numStoriesToLoad}
    />
  );
}
LoadMoreStories.propTypes = {
  data: PropTypes.object,
  stories: PropTypes.array
};
function LoadMoreStoriesTemplate(props) {
  const config = {
    "collection-name": `Results for ${props.tagName}`,
    "collection-color": "#e32313",
    hideLoadmore: true,
    limit: 20
  };
  return (
    <div>
      {props.stories.length ? (
        <FullscreenStoryList
          stories={props.stories}
          config={config}
          onLoadMore={props.onLoadMore}
          noMoreStories={props.noMoreStories}
        />
      ) : (
        <div className="component-wrapper">
          <p>
            No stories found for tag &#39; <strong>{props.tagName}</strong>&#39; .
          </p>
        </div>
      )}
    </div>
  );
}
LoadMoreStoriesTemplate.propTypes = {
  tagName: PropTypes.string,
  stories: PropTypes.array,
  onLoadMore: PropTypes.func,
  noMoreStories: PropTypes.bool
};

export { TagPage };
